import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import sharedSportsBank from 'assets/media/shared-sports-bank.jpg';
import Draggable from 'components/drag-and-drop/Draggable';
import { NewPageButton } from 'components/form-elements/buttons/NewPageButton';
import { SockerKickBallIcon } from 'assets/icons/brikks/SockerKickBallIcon';
import { LinkBrikkContent } from 'components/brikks/sub-components/LinkBrikkContent';
import { CircularImage } from 'components/brikks/sub-components/CircularImage';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';

export const SharedSportsBank = ({ position, status, code, name }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };
  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<SockerKickBallIcon />}
            heading="Shared Sports Bank"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <CircularImage
              src={sharedSportsBank}
              alt="Sporting equipment"
            />

            <LinkBrikkContent link="lund.se" />
          </Brikk.Content>

          <Brikk.Button>
            <NewPageButton
              label="Shared Sports Bank Link"
              to="https://lund.se/"
              brikkNameIntl="sportsBank"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Shared Sports Bank info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

    </>
  );
};
